<div class="container">
  <!-- <header-i18n showLangText="false" class="langs"></header-i18n> -->
  <div class="wrap">
    <div class="top">
      <div class="head">
        <img class="logo" src="{{this.ConfigInfo.ManageLogo}}" />
        <span class="title">{{this.ConfigInfo.ManageName}}</span>
      </div>
      <div class="desc"></div>
    </div>
    <router-outlet></router-outlet>
    <global-footer [links]="links">
      Copyright
      <i nz-icon nzType="copyright"></i> {{this.ConfigInfo.Copyright}}
    </global-footer>
  </div>
</div>
<!-- <theme-btn></theme-btn> -->
